import { Tooltip, TooltipProps } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { PropsWithChildren } from 'react'

const useStyles = makeStyles(() => ({
  tooltip: {
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: 'from-font',
    cursor: 'help',
  },
}))

export default function SimpleTooltip({ children, ...props }: PropsWithChildren<TooltipProps>) {
  const classes = useStyles()

  return (
    <Tooltip arrow enterTouchDelay={0} {...props}>
      <span className={classes.tooltip}>{children}</span>
    </Tooltip>
  )
}
